import { Box, Dialog, Stack } from '@mui/material'
import { ReactComponent as ArrowBack } from 'assets/arrow_back_logo.svg'
import { ReactComponent as CloseLogo } from 'assets/cross_close_logo.svg'
import { ICameraListItem } from 'models/IFrameInfo'
import { useState } from 'react'
import { COLORS } from 'styles/colors'
import { TypographyHeader } from 'ui/typography/TypographyHeader'
import { SelectDigitization } from './step1/Step1'
import { SelectTypeOfDigitization } from './step2/Step2'

type PropsType = {
	open: boolean
	onCloseModal: () => void
	cameraList: ICameraListItem[]
}

const DigitizatedModal = (props: PropsType) => {
	const { open, onCloseModal, cameraList } = props
	const [step, setStep] = useState<number>(1)
	const [cameraInfo, setCameraInfo] = useState<ICameraListItem>(undefined)

	return (
		<Dialog
			open={open}
			onClose={() => {
				setStep(1)
				setCameraInfo(undefined)
				onCloseModal()
			}}
			aria-labelledby='exit-warning-dialog-title'
			aria-describedby='exit-warning-dialog-description'
			PaperProps={{
				style: {
					borderRadius: '12px',
					boxShadow: 'none',
					width: '650px',
				},
			}}
		>
			<Box
				display={'flex'}
				flexDirection={'row'}
				justifyContent={'space-between'}
				alignItems={'center'}
				padding={'32px 24px 32px 24px'}
			>
				<Stack direction='row' gap='8px' alignItems='center'>
					{step === 2 && (
						<ArrowBack
							onClick={() => setStep(1)}
							style={{ cursor: 'pointer' }}
						/>
					)}
					<TypographyHeader>
						{step === 1
							? 'Шаг 1. Выберите место оцифровки'
							: 'Шаг 2. Выберите тип оцифровки'}
					</TypographyHeader>
				</Stack>
				<CloseLogo
					onClick={() => {
						setStep(1)
						setCameraInfo(undefined)
						onCloseModal()
					}}
					stroke={COLORS.secondary}
					style={{ cursor: 'pointer' }}
				/>
			</Box>
			{step === 1 ? (
				<SelectDigitization
					setStep={setStep}
					cameraList={cameraList}
					setCameraInfo={setCameraInfo}
				/>
			) : (
				<SelectTypeOfDigitization cameraInfo={cameraInfo} />
			)}
		</Dialog>
	)
}

export default DigitizatedModal
